var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inventory)?_c('div',{staticClass:"availability-feature"},[_c('availability-block',{attrs:{"inventory":_vm.inventory}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }